import { addMinutes, addWeeks, format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { ADMIN_DASHBOARD_API_CALL_TYPE, NAME_OF_PRODUCT_TYPES, REPORTING_TIMEZONE } from "./sf_constants";
import { percentFormatWithTwoDecimalPlaces } from "./sf_utils";
import _ from "lodash";

export const ADMIN_DASHBOARD_METRICS = {
  TOTAL_REVENUE: {
    name: 'Total Revenue',
    lead_metric: 'lead_analytic_total_cost',
    call_metric: 'call_analytic_total_cost',
    click_metric: 'click_analytic_total_cost',
    syndi_click_metric: 'click_analytic_total_upstream_bid',
    quote_funnels_metric: 'click_analytic_total_cost',
    all_product_metric: 'total_cost',
    common_metric: 'total_cost',
    key: 'TOTAL_REVENUE'
  },
  ALL_INVENTORY: {
    name: 'All Inventory',
    lead_metric: 'lead_analytic_total_inventory',
    call_metric: 'call_analytic_total_inventory',
    click_metric: 'click_analytic_total_inventory',
    syndi_click_metric: 'click_analytic_total_inventory',
    quote_funnels_metric: 'click_analytic_total_inventory',
    all_product_metric: 'total_inventory',
    common_metric: 'total_inventory',
    key: 'ALL_INVENTORY'
  },
  OPPORTUNITIES: {
    name: 'Opportunities',
    lead_metric: 'lead_analytic_total_opportunities',
    call_metric: 'call_analytic_total_opportunities',
    click_metric: 'click_analytic_total_opportunities',
    syndi_click_metric: 'click_analytic_total_opportunities',
    quote_funnels_metric: 'click_analytic_total_opportunities',
    all_product_metric: 'total_opportunities',
    common_metric: 'total_opportunities',
    key: 'OPPORTUNITIES'
  },
  TARGET_RATE: {
    name: 'Target Rate',
    lead_metric: 'lead_analytic_target_rate',
    call_metric: 'call_analytic_target_rate',
    click_metric: 'click_analytic_target_rate',
    syndi_click_metric: 'click_analytic_target_rate',
    quote_funnels_metric: 'click_analytic_target_rate',
    all_product_metric: 'target_rate',
    common_metric: 'target_rate',
    key: 'TARGET_RATE'
  },
  SEARCHES: {
    name: 'Searches',
    lead_metric: 'lead_analytic_total_searches',
    call_metric: 'call_analytic_total_searches',
    click_metric: 'click_analytic_total_searches',
    syndi_click_metric: 'click_analytic_total_searches',
    quote_funnels_metric: 'click_analytic_total_searches',
    all_product_metric: 'total_searches',
    common_metric: 'total_searches',
    key: 'SEARCHES'
  },
  BID_RATE: {
    name: 'Bid Rate',
    lead_metric: 'lead_analytic_bid_rate',
    call_metric: 'call_analytic_bid_rate',
    click_metric: 'click_analytic_bid_rate',
    syndi_click_metric: 'click_analytic_bid_rate',
    quote_funnels_metric: 'click_analytic_bid_rate',
    all_product_metric: 'bid_rate',
    common_metric: 'bid_rate',
    key: 'BID_RATE'
  },
  BIDS_WON: {
    name: 'Bids Won',
    lead_metric: 'lead_analytic_total_won',
    call_metric: 'call_analytic_total_calls',
    click_metric: 'click_analytic_impressions',
    syndi_click_metric: 'click_analytic_impressions',
    quote_funnels_metric: 'click_analytic_impressions',
    all_product_metric: 'total_won',
    common_metric: 'total_selected',
    key: 'BIDS_WON'
  },
  EPW: {
    name: 'EPW',
    lead_metric: 'lead_analytic_epw',
    call_metric: 'call_analytic_epw',
    click_metric: 'click_analytic_epw',
    syndi_click_metric: 'click_analytic_epw',
    quote_funnels_metric: 'click_analytic_epw',
    all_product_metric: 'epw',
    common_metric: 'epw',
    key: 'EPW'
  },
  WIN_RATE: {
    name: 'Win Rate',
    lead_metric: 'lead_analytic_win_rate',
    call_metric: 'call_analytic_win_rate',
    click_metric: 'click_analytic_win_rate',
    syndi_click_metric: 'click_analytic_win_rate',
    quote_funnels_metric: 'click_analytic_win_rate',
    all_product_metric: 'win_rate',
    common_metric: 'win_rate',
    key: 'WIN_RATE'
  },
  ACCEPTED: {
    name: 'Accepted',
    lead_metric: 'lead_analytic_total_leads',
    call_metric: 'call_analytic_billable_calls',
    click_metric: 'click_analytic_total_clicks',
    syndi_click_metric: 'click_analytic_total_clicks',
    quote_funnels_metric: 'click_analytic_total_clicks',
    all_product_metric: 'total_leads',
    common_metric: 'total_accepted',
    key: 'ACCEPTED'
  },
  CLICKS: {
    name: 'Clicks',
    syndi_click_metric: 'click_analytic_total_clicks',
    key: 'CLICKS'
  },
  SUCCESS_RATE: {
    name: 'Success Rate',
    lead_metric: 'lead_analytic_success_rate',
    call_metric: 'call_analytic_success_rate',
    click_metric: 'click_analytic_success_rate',
    syndi_click_metric: 'click_analytic_success_rate',
    quote_funnels_metric: 'click_analytic_success_rate',
    all_product_metric: 'success_rate',
    common_metric: 'success_rate',
    key: 'SUCCESS_RATE'
  },
  AVG_BID: {
    name: 'Avg Bid',
    lead_metric: 'lead_analytic_avg_bid',
    call_metric: 'call_analytic_avg_bid',
    click_metric: 'click_analytic_avg_bid',
    syndi_click_metric: 'click_analytic_avg_bid',
    quote_funnels_metric: 'click_analytic_avg_bid',
    all_product_metric: 'avg_bid',
    common_metric: 'avg_bid',
    key: 'AVG_BID'
  },
  AVG_CPL: {
    name: 'Cost per',
    lead_metric: 'lead_analytic_avg_cpl',
    call_metric: 'call_analytic_avg_cpc',
    click_metric: 'click_analytic_avg_cpc',
    syndi_click_metric: 'click_analytic_avg_cpc',
    quote_funnels_metric: 'click_analytic_avg_cpc',
    all_product_metric: 'avg_cpl',
    common_metric: 'cost_per',
    key: 'AVG_CPL'
  },
  UPSTREAM_BID: {
    name: 'Total Revenue',
    syndi_click_metric: 'click_analytic_total_upstream_bid',
    key: 'UPSTREAM_BID'
  },
  AVG_UPSTREAM_BID: {
    name: 'Avg Bid',
    syndi_click_metric: 'click_analytic_avg_upstream_bid',
    key: 'AVG_UPSTREAM_BID'
  },
  RPC: {
    name: "RPC",
    syndi_click_metric: 'rpc',
    key: "RPC"
  },
  CPC: {
    name: "CPC",
    syndi_click_metric: 'cost_per',
    key: "CPC"
  },
  TOTAL_COST: {
    name: "Total Cost",
    syndi_click_metric: 'click_analytic_total_cost',
    key: "TOTAL_COST"
  },
  GP_PER: {
    name: "GP Per",
    syndi_click_metric: 'gp_per',
    key: "GP_PER"
  },
  SYNDI_CLICK_PROFIT: {
    name: "Profit",
    syndi_click_metric: "syndi_click_profit",
    key: "PROFIT"
  },
  SYNDI_CLICK_CM: {
    name: "CM",
    syndi_click_metric: "syndi_click_cm",
    key: "CM"
  },
  LEADS_GENERATED: {
    name: 'Leads',
    quote_funnels_metric: 'click_analytics_leads_generated',
    key: 'LEADS_GENERATED'
  },
  CALLS_GENERATED: {
    name: 'Calls',
    quote_funnels_metric: 'click_analytics_calls_generated',
    key: 'CALLS_GENERATED'
  },
  QF_CONVERSION: {
    name: 'QF Conversion',
    quote_funnels_metric: 'qf_conversion',
    key: 'QF_CONVERSION'
  },
}

const TIMEFRAME_TYPES = {
  hour: 'hour',
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year'
}

export const getMetricKeyFromMetricNameRevamp = (productType, metricName) => {
  if (productType === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS) {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.syndi_click_metric
  } else if (productType === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.quote_funnels_metric
  } else {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.common_metric
  }
}


export const getMetricKeyFromMetricName = (productType, metricName) => {
  if (productType === NAME_OF_PRODUCT_TYPES.LEADS) {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.lead_metric
  } else if (productType === NAME_OF_PRODUCT_TYPES.CALLS) {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.call_metric
  } else if (productType === NAME_OF_PRODUCT_TYPES.CLICKS) {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.click_metric
  } else if (productType === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS) {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.syndi_click_metric
  } else if (productType === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.quote_funnels_metric
  } else {
    return ADMIN_DASHBOARD_METRICS[_.findKey(ADMIN_DASHBOARD_METRICS, { name: metricName })]?.all_product_metric
  }
}


export const getGraphDateOverTimeRangeAdminDashboard = (metricKey, lead_type_id, dateRanges, isCurrent) => {
  // dateRanges can be null (e.g. no date-range series for some product/group-by combinations);
  // guard it so the chart renders empty instead of throwing and blanking the whole dashboard.
  const ranges = dateRanges || [];
  let filtered_array = [];
  if (isCurrent === true) {
    filtered_array = ranges.filter((e) => (['from_comparision', 'to_comparision', 'prev'].includes(e.meta) === false) && (e?.['lead_type_id'] === lead_type_id));
  } else {
    filtered_array = ranges.filter((e) => (['prev'].includes(e?.meta) === true) && (e?.['lead_type_id'] === lead_type_id));
  }
  return filtered_array?.map((e) => e?.[metricKey] || 0);
};

export const DOLLAR_FORMATTER_METRICS = [
  ADMIN_DASHBOARD_METRICS.TOTAL_REVENUE.name,
  ADMIN_DASHBOARD_METRICS.AVG_BID.name,
  ADMIN_DASHBOARD_METRICS.AVG_CPL.name,
  ADMIN_DASHBOARD_METRICS.EPW.name,
  ADMIN_DASHBOARD_METRICS.CPC.name,
  ADMIN_DASHBOARD_METRICS.RPC.name,
  ADMIN_DASHBOARD_METRICS.GP_PER.name,
  ADMIN_DASHBOARD_METRICS.SYNDI_CLICK_PROFIT.name,
  ADMIN_DASHBOARD_METRICS.TOTAL_COST.name
]

export const PERCENTAGE_FORMATTER_METRICS = [
  ADMIN_DASHBOARD_METRICS.TARGET_RATE.name,
  ADMIN_DASHBOARD_METRICS.BID_RATE.name,
  ADMIN_DASHBOARD_METRICS.WIN_RATE.name,
  ADMIN_DASHBOARD_METRICS.SUCCESS_RATE.name,
  ADMIN_DASHBOARD_METRICS.SYNDI_CLICK_CM.name,
  ADMIN_DASHBOARD_METRICS.QF_CONVERSION.name
]

export const NUMBER_FORMATTER_METRICS = [
  ADMIN_DASHBOARD_METRICS.ALL_INVENTORY.name,
  ADMIN_DASHBOARD_METRICS.OPPORTUNITIES.name,
  ADMIN_DASHBOARD_METRICS.SEARCHES.name,
  ADMIN_DASHBOARD_METRICS.BIDS_WON.name,
  ADMIN_DASHBOARD_METRICS.ACCEPTED.name,
]

export const adminDashboardPercentageFormatter = (value) => {
  return percentFormatWithTwoDecimalPlaces(value * 100)
}

export const adminDashboardRevampPercentageFormatter = (value) => {
  return percentFormatWithTwoDecimalPlaces(value)
}

export const parseAdminDashboardAPIPayload = (payload, api_type, ianaTz = REPORTING_TIMEZONE) => {
  switch (api_type) {
    case ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_DATE_RANGES:
    case ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_DATE_RANGES:
    case ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_DATE_RANGES:
    case ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_DATE_RANGES:
    case ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_DATE_RANGES:
    case ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_DATE_RANGES:
      {
        const ret = payload.map(period_data => {
          if (period_data.meta) {
            return period_data;
          }
          let meta = '';
          const zonedStart = utcToZonedTime(period_data.timeframe_start, ianaTz);
          switch (period_data.timeframe_type) {
            case TIMEFRAME_TYPES.hour:
              meta = `${format(zonedStart, 'hh:mm a')} - ${format(addMinutes(zonedStart, 59), 'hh:mm a')}`
              break;
            case TIMEFRAME_TYPES.day:
              meta = `${format(zonedStart, 'LLL dd')}`;
              break;
            case TIMEFRAME_TYPES.week:
              meta = `${format(zonedStart, 'LLL dd')} - ${format(addWeeks(zonedStart, 1), 'LLL dd')}`
              break;
            case TIMEFRAME_TYPES.month:
              meta = `${format(zonedStart, 'MMM yy')}`;
              break;
            case TIMEFRAME_TYPES.year:
              meta = `${format(zonedStart, 'yyyy')}`;
              break;
          }
          return {
            ...period_data,
            meta
          }
        })
        return ret;
      }
    default:
      return payload;
  }
}

export const parseAdminDashboardAPIPayloadRevamp = (payload, ianaTz = REPORTING_TIMEZONE) => {
  const ret = payload.map(period_data => {
    if (period_data.meta) {
      return period_data;
    }
    let meta = '';
    const zonedStart = utcToZonedTime(period_data.timeframe_start, ianaTz);
    switch (period_data.timeframe_type) {
      case TIMEFRAME_TYPES.hour:
        meta = `${format(zonedStart, 'hh:mm a')} - ${format(addMinutes(zonedStart, 59), 'hh:mm a')}`
        break;
      case TIMEFRAME_TYPES.day:
        meta = `${format(zonedStart, 'LLL dd')}`;
        break;
      case TIMEFRAME_TYPES.week:
        meta = `${format(zonedStart, 'LLL dd')} - ${format(addWeeks(zonedStart, 1), 'LLL dd')}`
        break;
      case TIMEFRAME_TYPES.month:
        meta = `${format(zonedStart, 'MMM yy')}`;
        break;
      case TIMEFRAME_TYPES.year:
        meta = `${format(zonedStart, 'yyyy')}`;
        break;
    }
    return {
      ...period_data,
      meta
    }
  })
  return ret;
}

// export const dataFormatterForAdminDashboard = (metricName) => {
//   if (DOLLAR_FORMATTER_METRICS.includes(metricName)) {
//     return dollarFormatWithTwoDecimalPlaces
//   } else if (PERCENTAGE_FORMATTER_METRICS.includes(metricName)) {
//     return adminDashboardPercentageFormatter
//   } else if (NUMBER_FORMATTER_METRICS.includes(metricName)) {
//     return Sfdelimitter
//   }
// }
